export default __webpack_public_path__ + "static/media/f17f16a9-09cc-4170-a039-5f47a4948438.1f6ef153.woff";